module.exports = __webpack_public_path__ + "media/images/package-team-1b19a2d76385808657a914293379be56.svg";